import React from "react";
import { Checkbox, Col, Form, FormInstance, Input, Row, } from "antd";

import { AccountInfo } from "services/rest/request";

import "./ContactInfo.less";
import { useIntl } from "react-intl";

export type ContactInfoProps = {
  form: FormInstance<AccountInfo>,
  onChange: () => void
}

export function ContactInfo(props: ContactInfoProps) {
  const intl = useIntl();

  return (
    <>
      <div className="account-settings__title">
        {intl.formatMessage({id: "jmix-account.contact-info.title"})}
      </div>
      <Form
        form={props.form}
        onChange={props.onChange}
        layout="vertical"
        className="contact-info__form"
      >
        <Row gutter={32}>
          <Col flex="1 0 300px">
            <Form.Item
              label={intl.formatMessage({id: "jmix-account.contact-info.first-name"})}
              name="firstName"
              required
              rules={[
                {
                  message: intl.formatMessage({id: "jmix-account.contact-info.first-name.rule"}),
                  required: true,
                }
              ]}
            >
              <Input placeholder={intl.formatMessage({id: "jmix-account.contact-info.first-name.placeholder"})}/>
            </Form.Item>
          </Col>
          <Col flex="1 0 300px">
            <Form.Item
              label={intl.formatMessage({id: "jmix-account.contact-info.last-name"})}
              name="lastName"
              required
              rules={[
                {
                  message: intl.formatMessage({id: "jmix-account.contact-info.last-name.rule"}),
                  required: true,
                }
              ]}
            >
              <Input placeholder={intl.formatMessage({id: "jmix-account.contact-info.last-name.placeholder"})}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col flex="1 0 300px">
            <Form.Item
              label={intl.formatMessage({id: "jmix-account.contact-info.email"})}
              name="email"
              required
              rules={[
                {
                  message: intl.formatMessage({id: "jmix-account.contact-info.email.rule"}),
                  required: true,
                }
              ]}
            >
              <Input
                disabled
                placeholder={intl.formatMessage({id: "jmix-account.contact-info.email.placeholder"})}
              />
            </Form.Item>
          </Col>
          <Col flex="1 0 300px">
            <Form.Item
              label={intl.formatMessage({id: "jmix-account.contact-info.company-name"})}
              name="company"
            >
              <Input
                placeholder={intl.formatMessage({id: "jmix-account.contact-info.company-name.placeholder"})}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item
            name="newsletter"
            valuePropName="checked"
            extra={intl.formatMessage({id: "jmix-account.contact-info.subscribe-checkbox.description"})}>
            <Checkbox>
              {intl.formatMessage({id: "jmix-account.contact-info.subscribe-checkbox.name"})}
            </Checkbox>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}